/**
 * Normalize a Date to start of day (00:00:00.000).
 * Always returns a new Date object.
 */
export const normalizeDayStart = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
};

/**
 * Normalize a Date to end of day (23:59:59.999).
 * Always returns a new Date object.
 */
export const normalizeDayEnd = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
};

/**
 * Normalize a [start, end] date-range array to day bounds.
 * Returns null if the range is missing or invalid.
 */
export const normalizeDateRange = (startEndDate) => {
    if (!startEndDate || !startEndDate[0] || !startEndDate[1]) {
        return null;
    }
    return [normalizeDayStart(startEndDate[0]), normalizeDayEnd(startEndDate[1])];
};

/**
 * Build a complete form-value object with normalized date range fields.
 * Falls back to today's full day if filters.start_end_date is missing/invalid.
 *
 * Adds convenience fields `start_date` and `end_date` alongside `start_end_date`.
 */
export const buildDateFilterFormValue = (filters) => {
    const normalized = normalizeDateRange(filters?.start_end_date);
    const startDate = normalized ? normalized[0] : normalizeDayStart(new Date());
    const endDate = normalized ? normalized[1] : normalizeDayEnd(new Date());

    return {
        ...filters,
        start_end_date: [startDate, endDate],
        start_date: startDate,
        end_date: endDate,
    };
};
